import { cloudApi } from './http.js'

function profilePath(tenantId, projectId) {
  return `/api/tenants/${encodeURIComponent(tenantId)}/projects/${encodeURIComponent(projectId)}/enterprise-profile`
}

export const enterpriseProfileApi = Object.freeze({
  validateUrls(tenantId, projectId, urls, options = {}) {
    return cloudApi.post(`${profilePath(tenantId, projectId)}/validate-urls`, { urls }, options)
  },
  get(tenantId, projectId, options = {}) {
    return cloudApi.get(profilePath(tenantId, projectId), options)
  },
  saveDraft(tenantId, projectId, body, options = {}) {
    return cloudApi.put(`${profilePath(tenantId, projectId)}/draft`, body, options)
  },
  publish(tenantId, projectId, body, options = {}) {
    return cloudApi.post(`${profilePath(tenantId, projectId)}/versions`, body, options)
  },
})
